import { render, staticRenderFns } from "./listaEvaluaciones.vue?vue&type=template&id=353b0451"
import script from "./listaEvaluaciones.vue?vue&type=script&lang=js"
export * from "./listaEvaluaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports